export const convertUnderscoreToSpace = (str) => {
  return str.replace(/_/g, " ");
};

export const convertSpaceToUnderscore = (str) => {
  return str.replace(/ /g, "_");
};
